export const CHECKOUT_LABELS = 'checkout';
export const GLOBAL_LABELS = 'global';

const BossUnavailableLabels = {
  checkout: {
    bagPage: {
      lbl_qty_text: 'Qty',
      lbl_boss_unavailable_confirmation_sub_text: 'Ship them to your home for FREE!',
      lbl_boss_unavailable_confirmation_heading_only_oss_items: 'Update on cart remaining items!',
      lbl_boss_unavailable_confirmation_error_text:
        "Some of the product we've held are no longer available",
      lbl_orderledger_free: 'FREE',
      lbl_boss_unavailable_confirmation_heading: 'We’ve saved the rest of the items in your bag...',
    },
    shipping: {
      lbl_shipping_header: 'SHIPPING',
    },
  },
  global: {
    addedToBagModal: {
      lbl_cta_viewBag: 'View Bag',
    },
  },
};

export default BossUnavailableLabels;
